<app-modal-layout
    class="block w-full md:w-[35.5rem]"
    [containerLayout]="containerLayout"
    (closeModal)="forceWithValidation()"
    *transloco="let tFieldConfiguration; read: 'fields_configuration'"
>
    <ng-container title>{{ tFieldConfiguration('fields_configuration') }}</ng-container>
    <ng-container subtitle>{{
        tFieldConfiguration('fields_configuration_description')
    }}</ng-container>

    <app-tb-tabs
        [tabs]="tabs"
        [activeTab]="selectedTab"
        (tabOpened)="selectedTab = $event"
    ></app-tb-tabs>

    @if (fieldsByTab[selectedTab.id]; as fields) {
        <div class="my-3" *transloco="let tFieldTypeName; read: 'field_type.name'">
            @if (fields.templateFields) {
                <div
                    class="flex flex-wrap max-xsm:flex-col mb-4 max-xsm:gap-2 gap-4 positionChildElementsByHalves"
                >
                    @for (field of fields.templateFields; track field.guid) {
                        <app-field-configuration-type
                            [active]="!inactiveFields.includes(field.guid)"
                            [name]="field.name || tFieldConfiguration('no_name')"
                            [description]="tFieldTypeName(field.field_type_code)"
                            [icon]="getFieldIcon(field.field_type_code)"
                            (settings)="editField(field, 'templateFields')"
                            (activeChange)="activeChanged($event, field.guid)"
                        ></app-field-configuration-type>
                    }
                </div>

                <app-tb-divider></app-tb-divider>
            }

            <div
                class="flex flex-wrap max-xsm:flex-col max-xsm:gap-2 gap-4 positionChildElementsByHalves"
                [class.mt-4]="fields.templateFields"
            >
                <div
                    (click)="addField()"
                    class="flex justify-between items-center xsm:p-4 p-2 rounded-2xl shadow-md text-primaryLight hover:text-primary cursor-pointer"
                >
                    <div class="flex gap-2 items-center">
                        <app-tb-icon class="icon-lg" icon="add_circle_outline"> </app-tb-icon>
                        <div class="body-2">{{ tFieldConfiguration('add_field') }}</div>
                    </div>
                </div>

                @for (field of fields.newFields; track field.guid) {
                    <app-field-configuration-type
                        [active]="!inactiveFields.includes(field.guid)"
                        [name]="field.name || tFieldConfiguration('no_name')"
                        [description]="tFieldTypeName(field.field_type_code)"
                        [icon]="getFieldIcon(field.field_type_code)"
                        (settings)="editField(field, 'newFields')"
                        (activeChange)="activeChanged($event, field.guid)"
                    ></app-field-configuration-type>
                }
            </div>
        </div>
    }

    <app-modal-layout-buttons
        buttons
        *transloco="let tButtons; read: 'buttons'"
        [primary]="true"
        [cancel]="true"
    >
        <app-tb-button primary (click)="goBack()" [appearance]="'outlined'" class="mr-4">
            {{ tButtons('cancel') }}
        </app-tb-button>
        <app-tb-button cancel (click)="applyChanges()"> {{ tButtons('apply') }}</app-tb-button>
    </app-modal-layout-buttons>
</app-modal-layout>
